module.exports = __webpack_public_path__ + "img/touch-icon-ipad.5b1687d6.png";